import React from 'react';

const Description = ({items}) => {
    return (
        <>
      
            <div className='desc__need__box'>
              <div className="desc__need__desc iransans-b">
                شرح نیاز
              </div>
              <div className="desc__need__container iransans-b">
                <p>{items.needDescription}</p>
              </div>
            </div>
            <div className="desc__need__bottom">
                <div className="desc__need__end iransans-b">
                    <span>مصاحبه کننده</span>
                </div>
                <div className="desc__need__end iransans-b">
                    <span>مهر</span>
                </div>
                <div className="desc__need__end iransans-b">
                    <span>امضا</span>
                </div>
            </div>
        
        </>
    );
};

export default Description;